
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/song-questions",
      function () {
        return require("private-next-pages/song-questions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/song-questions"])
      });
    }
  